module.exports = __webpack_public_path__ + "school/img/back2.bce8820c.jpg";